import { MantineSpacing, StyleProp, Title } from '@mantine/core';

import classes from './index.module.css';

interface ISectionTitle {
  center?: boolean;
  pb?: StyleProp<MantineSpacing>;
  pt?: StyleProp<MantineSpacing>;
  title: React.ReactNode;
  variant?: string;
}

const SectionTitle = ({
  center,
  pb,
  pt,
  title,
  variant = 'light'
}: ISectionTitle) => {
  return (
    <Title ta={`${center ? 'center' : 'left'}`} className={`${classes.title} ${classes[variant]}`} pb={pb} pt={pt}>{title}</Title>
  );
}

export default SectionTitle;